import { createFileRoute, Link } from "@tanstack/react-router"
import { Activity, ArrowLeft } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import type { RunDetail } from "@/api/generated/RunDetail"
import { PageContainer, PageHeader } from "@/components/app/page"
import { Button } from "@/components/ui/button"
import { RunDetailView, RunHeadline } from "@/features/runs/run-detail"

export const Route = createFileRoute("/_app/insights/runs/$runId")({
  staticData: { titleKey: "insights.runs.detailTitle" },
  component: RunPage,
})

function RunPage() {
  const { t } = useTranslation()
  const { runId } = Route.useParams()
  const [run, setRun] = useState<RunDetail>()
  return (
    <PageContainer width="default">
      <PageHeader
        icon={Activity}
        title={run?.agent_name ?? t("insights.runs.detailTitle")}
        documentTitle={t("insights.runs.detailTitle")}
        description={run ? <RunHeadline run={run} /> : undefined}
        actions={
          <Button variant="outline" size="sm" nativeButton={false} render={<Link to="/insights/runs" />}>
            <ArrowLeft />
            {t("insights.runs.backToList")}
          </Button>
        }
      />
      <RunDetailView runKey={runId} onLoaded={setRun} />
    </PageContainer>
  )
}
